import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { CloudImage } from '@components/CloudImage';
import { themeColor, themeMediaQuery, themeSpace, themeVariant } from '@utils/styledTheme.util';

export const Vendors = styled(Box)`
  border-top: 1px solid ${themeColor('mono4')};
  border-bottom: 1px solid ${themeColor('mono4')};
`;

export const StyledText = styled(Text)`
  font-size: 20px;
  line-height: 32px;
  ${themeMediaQuery('below_sm')} {
    font-size: 17px;
    line-height: 27px;
    max-width: 295px;
    text-align: center;
    margin: auto;
  }
`;

export const StyledBox = styled(Box)`
  ${themeMediaQuery('xl')} {
    margin-top: ${themeSpace(9)};
  }
`;

export const StyledCloudImage = styled(CloudImage)`
  border-radius: ${themeSpace(3)};
  transition: transform 0.8s ease;
`;

export const Department = styled(Flex)`
  width: 270px;
  border-radius: ${themeSpace(3)};
  position: relative;
  overflow: hidden;
  transition: transform 0.5s ease;

  &:hover {
    transform: scale(1.05);
    ${StyledCloudImage} {
      transform: scale(1.15);
    }
  }

  ${themeMediaQuery('below_sm')} {
    width: 193px;
  }
`;

export const Overlay = styled(Box)`
  z-index: 1;
  position: absolute;
  left: 50%;
  width: max-content;
  bottom: ${themeSpace(7)};
  transform: translate(-50%, 0px);
`;

export const DepartmentText = styled(Text)`
  ${themeMediaQuery('below_sm')} {
    ${themeVariant('featureHed17')};
  }
`;
